//  function to synchronize the alo_auth_token

import { aloApiAuthFetch, aloApiFetch } from 'src/scripts/utils/alo-api-fetch';
import { getCookie } from './cookies';
import { Customer } from './environment';

export interface CookieResponse {
  status: string;
  message: string;
}

const ALO_AUTH_TOKEN = process.env.REACT_APP_ALO_AUTH_TOKEN || 'alo_auth_token_state';

// Function to sync the auth token cookie with the server
// This function will be called when the customer logs in or logs out
// It will send the customer's email to the server to update the auth token cookie
const syncCookieWithServer = async () => {
  try {
    const fetchCookie = await aloApiAuthFetch('/v1/wiz/cookie', {
      method: 'POST',
      credentials: 'include',
    });
    if (!fetchCookie.ok) {
      console.error(`HTTP error! status: ${fetchCookie.status}`);
      return;
    }
    const cookieResponse: CookieResponse = await fetchCookie.json();
    if (cookieResponse.status === 'success') return;
    if (cookieResponse.status === 'error') console.error(cookieResponse.message);
  } catch (error) {
    console.error('Fetch request to sync cookie failed.', error);
  }
};

const clearAuthTokenCookie = async () => {
  try {
    const fetchCookie = await aloApiFetch('/v1/wiz/cookie', {
      method: 'DELETE',
      headers: { 'X-Cookie-Domain': window.location.hostname.replace('www.', '') },
      credentials: 'include',
    });
    if (!fetchCookie.ok) {
      console.error(`HTTP error! status: ${fetchCookie.status}`);
      return;
    }
    const cookieResponse: CookieResponse = await fetchCookie.json();
    if (cookieResponse.status === 'success') return;
    if (cookieResponse.status === 'error') console.error(cookieResponse.message);
  } catch (error) {
    console.error('Fetch request to delete cookie failed.', error);
  }
};

export const synchronizeAloAuthToken = async () => {
  const rawCookieEmail = getCookie(ALO_AUTH_TOKEN);
  const cookieEmail = rawCookieEmail ? rawCookieEmail.replace(/^"|"$/g, '') : null;
  const { email, id } = Customer;
  const isCustomerLoggedIn = Boolean(id);
  // If the customer is logged in
  if (isCustomerLoggedIn) {
    if (cookieEmail !== email) {
      await syncCookieWithServer();
    }
  } else {
    if (cookieEmail) {
      // If the customer logged out
      await clearAuthTokenCookie();
    }
  }
};
